module.exports = "pegasus/assets/themelp1/small/9.png";